import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.snapdoc";
export interface MediaId {
    mediaListId: string;
}
function createBaseMediaId(): MediaId {
    return { mediaListId: "0" };
}
export const MediaId: MessageFns<MediaId> = {
    encode(message: MediaId, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.mediaListId !== "0") {
            writer.uint32(8).int64(message.mediaListId);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): MediaId {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMediaId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.mediaListId = reader.int64().toString();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<MediaId>, I>>(base?: I): MediaId {
        return MediaId.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<MediaId>, I>>(object: I): MediaId {
        const message = createBaseMediaId();
        message.mediaListId = object.mediaListId ?? "0";
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
